import React, { useState } from "react";
import "./Layout.css";
import Footer from "./footer/Footer";
import Header from "./header/Header";
import Main from "./main/Main";
import { useAuth } from "../../hooks/useAuth";
import SurveyPage from "../survey/SurveyPage";
import RegisterPage from "../login/RegisterPage";
import UsersStatusEnum from "../../constants/UsersStatusEnum";
import { Box, Button } from "@mui/material";
import Loader from "../UI/Loader";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS, USER_SURVEY_STATUS } from "constants/common";
import { userApi } from "services/api";
import ErrorMsg from "components/admin/UI/ErrorMessage";
import QuestionerSurveyPage from "components/questioner-survey";

function Layout() {
  const { user, logout, logoutLoading } = useAuth();
  const [updateSurvey, setUpdateSurvey] = useState(false);
  const { isLoading, isError, data } = useQuery({
    queryKey: [CACHE_KEYS.QUESTIONER_ANSWER, "STATUS"],
    queryFn: () => userApi.getUserSurveyStatus(),
  });

  if (isError) {
    return <ErrorMsg error={"Error fetching survey form"} />;
  }

  if (!user || isLoading) {
    return <Loader />;
  }

  let content;

  switch (user?.status) {
    case UsersStatusEnum.Survey:
      if (
        data?.data?.questioner &&
        [USER_SURVEY_STATUS.PENDING, USER_SURVEY_STATUS.IN_PROGRESS].includes(
          data?.data?.status
        )
      ) {
        content = <QuestionerSurveyPage questioner={data?.data?.questioner} />;
      } else {
        content = <SurveyPage />;
      }
      break;
    case UsersStatusEnum.Pending:
    case UsersStatusEnum.Approved:
      if (
        data?.data?.questioner &&
        ([USER_SURVEY_STATUS.OUTDATED, USER_SURVEY_STATUS.IN_PROGRESS].includes(
          data?.data?.status
        ) ||
          updateSurvey)
      ) {
        content = (
          <QuestionerSurveyPage
            handleBack={() => {
              setUpdateSurvey(false);
            }}
            visibleBackButton={updateSurvey}
            questioner={data?.data?.questioner}
          />
        );
      } else {
        content = (
          <div className="parent">
            <Header
              startSurvey={() => {
                setUpdateSurvey(true);
              }}
              isOutDated={data?.data?.status === USER_SURVEY_STATUS.OUTDATED}
              inProgress={data?.data?.status === USER_SURVEY_STATUS.IN_PROGRESS}
            />
            <Main />
            <Footer />
          </div>
        );
      }
      break;
    // 'registration' and default case render the same content
    case UsersStatusEnum.Registration:
    default:
      content = <RegisterPage />;
  }

  return (
    <Box>
      {user?.status === UsersStatusEnum?.Registration ? (
        <Box mx={2} my={2} sx={{ display: "flex", justifyContent: "end" }}>
          <Button disabled={logoutLoading} variant="contained" onClick={logout}>
            {logoutLoading ? "Logging out..." : "Logout"}
          </Button>
        </Box>
      ) : (
        <></>
      )}
      <Box>{content}</Box>
    </Box>
  );
}

export default Layout;
